<template>
  <div>
    <el-dialog
        title="Mover Arquivo para"
        :visible.sync="outerVisible"
    >
      <el-breadcrumb
          separator="/"
          style="padding-bottom: 16px;"
      >
        <el-breadcrumb-item v-for="path in paths">
          <a @click="backToFolder(path); salvaPath(path.id)">{{ path.folder_name }}</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <el-dialog
          width="30%"
          title="Inner Dialog"
          :visible.sync="innerVisible"
          append-to-body
      />

      <el-row
          slot="footer"
          type="flex"
          class="dialog-footer"
      >
        <!--        <el-col>-->
        <!--          <el-row>-->
        <!--            <el-col-->
        <!--                :span="6"-->
        <!--                :offset="6"-->
        <!--            >-->
        <!--              <el-pagination-->
        <!--                  background-->
        <!--                  layout="prev, pager, next"-->
        <!--                  :total="3"-->
        <!--              />-->
        <!--            </el-col>-->
        <!--          </el-row>-->
        <!--        </el-col>-->
      </el-row>
      <div
          slot="footer"
          class="demo-inline-spacing dialog-footer d-flex justify-content-end "
      >
        <b-button
            @click="cancelMoverFolder"
            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
            variant="outline-dark"
        >
          Cancelar
        </b-button>
        <b-button
            @click="moverObjeto(folderVideoSelected)"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
        >
          Mover para {{ itemFolder.folder_name }}
        </b-button>
      </div>
      <div
          v-loading="loading"
          class="container"
      >
        <div class="ant-modal-body">
          <span class="ant-input-affix-wrapper ant-input-affix-wrapper-lg sc-eVspGN helizw">
            <el-input
                v-model="filterName"
                class="ant-input ant-input-lg"
                placeholder="Pesquisa por nome"
                suffix-icon="el-icon-search"
            />
          </span>
          <ul class="sc-fmPOXC cOQaLE">
            <li
                v-for="item of listarMoverFolders"
                :key="item.id"
                class="sc-fIhvWL XeRPi hvr-glow "
                :class="{ 'sc-fIhvWL XeRPi hvr-glow': folderVideoSelected.filter(i=> i.id === item.id).length === 0, 'sc-fIhvWL XeRPi hvr-glow disabled':  folderVideoSelected.filter(i=> i.id === item.id).length > 0 }"
                @click="getFolder(item)"

            >
              <span
                  role="img"
                  aria-label="folder"
                  class="anticon anticon-folder sc-gzrROc dfkVph"
              >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 48 48"
                    width="1em"
                    height="1em"
                >
                  <path
                      fill=""
                      d="M40,12H22l-4-4H8c-2.2,0-4,1.8-4,4v8h40v-4C44,13.8,42.2,12,40,12z"
                  />
                  <path
                      fill="#671717"
                      d="M40,12H22l-4-4H8c-2.2,0-4,1.8-4,4v8h40v-4C44,13.8,42.2,12,40,12z"
                  />
                  <path
                      fill="#bb0404"
                      d="M40,12H8c-2.2,0-4,1.8-4,4v20c0,2.2,1.8,4,4,4h32c2.2,0,4-1.8,4-4V16C44,13.8,42.2,12,40,12z"
                  />
                </svg>
              </span>
              <div class="sc-gkSfol gOiYZd">
                <strong>{{ item.folder_name }}</strong>
              </div>
            </li>
          </ul>
        </div>

      </div>
    </el-dialog>
    <el-card
        v-if="folderVideoSelected.length != 0"
        id="card-checked"
        shadow="always"
    >
      <el-row
          id="card-main"
          type="flex"
          class="row-bg"
          justify="space-between"
      >
        <el-col
            class="align-self-center"
            :span="4"
        >
          <el-checkbox
              v-model="checked"
              @change="isCheckedAll"
          >{{ folderVideoSelected.length }} {{
              arquivos
            }}
          </el-checkbox>
        </el-col>
        <el-col :span="4">
          <el-button
              plain
              icon="el-icon-top"
              @click="getAllMainfolders() "
          >
            Mover Arquivo Para
          </el-button>
        </el-col>
        <el-col :span="4">
          <el-button
              type="danger"
              icon="el-icon-delete"
              @click="deletarArquivosSelecionados"
          >
            Deletar Arquivo
          </el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import mock from '@/services/mock.json'
import { useApi, useApiAWS } from '@/composables/useApi'
import { mapActions, mapState } from 'vuex'
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { VslService } from '@/services/Vsl'
import axios from 'axios'

const api = useApi()
const apiAws = useApiAWS()

export default {
  components: {
    BButton,
  },
  directives: {
    Ripple,
  },
  props: ['value', 'folders', 'videos', 'checked'],
  data() {
    return {

      listarMoverFolders: [],
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || "/api/dkbackend",
      loading: false,
      paths: [],
      itemFolder: '',
      videosPlay: [],
      filterName: '',
      outerVisible: false,
      innerVisible: false,
      arquivos: 'Pasta(s) selecionada(s)',
      drawer: false,
      direction: 'btt',
      mock,
    }
  },
  computed: {

    isCheckedAllFolderVideos: {
      get() {
        return this.checked
      },
      set(val) {
        this.$emit('updatedChecked', val)
      },
    },
    getAllVideos: {
      get() {
        return this.videos
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    folderVideoSelected: {

      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
  },
  mounted() {
    this.getFolderByIdMain(0)
    this.getPlayerVideos({id: 0})
    this.listarVideos()
    this.getAllFolderUser()
  },

  methods: {
    ...mapActions('Videos', ['listarVideos']),
    ...mapActions('Folders', ['getAllFolderUser', 'getAllMoverFolder']),
    async getAllMainfolders() {
      await this.getAllMoverFolder({
        id_main: 0
      }).then((res) => {
        console.log('res', res)
        this.listarMoverFolders = res
      })
      console.log('listaFolder', this.listarMoverFolders)
      this.outerVisible = true;
    },
    async cancelMoverFolder() {
      this.outerVisible = false
      this.paths = []
      this.loading = true
      this.$store.commit('Folders/setIdMainParams', 0)
      await this.$store.dispatch('Folders/getAllFolderUser')
          .finally(() => {
            this.loading = false
          })
    },
    moverObjeto(folderVideoSelected) {
      const folders = 'folders'
      if (folderVideoSelected[0].file_type === folders) {
        fetch(`${this.VUE_APP_HOST_API_BACKEND}/updateFolderId_main/${folderVideoSelected[0].id}`, {
          method: 'PUT',
          headers: {'Content-Type': 'application/json'},
          body: `{"id_main":"${this.itemFolder.id}"}`,
        })
            // .then(response => response.json())
            .then(response => {
              this.getAllFolderUser().then(res => {
                console.log('res', res)
              })
              this.outerVisible = false
              this.$message({
                message: 'Arquivos foram movidos com sucesso.',
                type: 'success',
              })
            })
            .catch(err => console.error(err))
      } else {
        fetch(`${this.VUE_APP_HOST_API_BACKEND}/updateVslFolderId/${folderVideoSelected[0].id}`, {
          method: 'PUT',
          headers: {'Content-Type': 'application/json'},
          body: `{"id_folder":"${this.itemFolder.id}"}`,
        })
            // .then(response => response.json())
            .then(response => {
              this.listarVideos()
              this.folderVideoSelected = []
              this.outerVisible = false
              this.$message({
                message: 'Arquivos foram movidos com sucesso.',
                type: 'success',
              })
            })
            .catch(err => console.error(err))
      }
    },
    isCheckedAll() {
      this.$emit('updatedChecked', this.checked)
      if (!this.checked) {
        this.getAllFolders.map(f => f.is_selected = false)
        this.getAllVideos.map(v => v.is_selected = false)
        this.folderVideoSelected = []
      }
      this.getAllFolders.map(f => {
        if (this.folderVideoSelected.indexOf(f) === -1) {
          this.folderVideoSelected.push(f)
          f.is_selected = true
        }
      })
      this.getAllVideos.map(v => {
        if (this.folderVideoSelected.indexOf(v) === -1) {
          this.folderVideoSelected.push(v)
          v.is_selected = true
        }
      })
    },
    async backToFolder(item) {
      this.loading = true
      const indexItem = this.paths.indexOf(item)
      this.paths.forEach((p, i) => {
        if (i > indexItem) {
          this.paths.splice(i, 1)
        }
      })
      await this.getAllMoverFolder({
        id_main: item.id
      }).then((res) => {
        console.log('res', res)
        this.listarMoverFolders = res
      })
      this.loading = false
    },
    async getFolder(item) {
      this.loading = true
      this.itemFolder = item
      if (this.paths.length === 0) {
        this.paths.push({
          folder_name: 'Raiz',
          id: 0,
        })
      }
      const res = this.paths.find(f => f.id === item.id)
      if (res === undefined) {
        this.paths.push(item)
      }

      await this.getAllMoverFolder({
        id_main: item.id
      }).then((res) => {
        console.log('res', res)
        this.listarMoverFolders = res
      })


      this.loading = false
    },
    async getFolderByIdMain(id_main) {
      const params = {
        id_main,
      }
      await api.get(`/folderUser/${this.getUserData.id}`, {
        params,
      })
          .then(resp => {
            this.$emit('update:folders', resp.data)
          })
    },
    async getPlayerVideos(id_folder) {
      let params = null
      if (id_folder) {
        params = {
          id_folder: id_folder.id,
        }
      }
      await api.get(`/vslUserId/${this.getUserData.id}`, {
        params,
      })
          .then(resp => {
            this.videosPlay = resp.data
          })
    },
    
    // Métodos para deletar arquivos selecionados
    deletarArquivosSelecionados() {
      const videosParaDeletar = this.folderVideoSelected.filter(item => item.file_type !== 'folders')
      
      if (videosParaDeletar.length === 0) {
        this.$message({
          type: 'warning',
          message: 'Nenhum vídeo selecionado para deletar',
        })
        return
      }
      
      const quantidade = videosParaDeletar.length
      const mensagem = quantidade === 1
        ? 'Você tem certeza que deseja deletar este vídeo?'
        : `Você tem certeza que deseja deletar estes ${quantidade} vídeos?`
      
      this.$confirm(mensagem, {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'Deletar Videos',
      }).then(res => {
        if (res) {
          this.processarDelecaoVideos(videosParaDeletar)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete cancelado',
        })
      })
    },
    
    async processarDelecaoVideos(videos) {
      this.loading = true
      
      try {
        // Processar deletação de todos os vídeos em paralelo
        await Promise.all(videos.map(video => this.deletarVideoCompleto(video)))
        
        // Limpar seleção e atualizar lista
        this.folderVideoSelected = []
        this.$emit('updatedChecked', false)
        this.listarVideos()
        
        this.$message({
          type: 'success',
          message: 'Vídeos deletados com sucesso',
        })
      } catch (error) {
        console.error('Erro ao deletar vídeos:', error)
        this.$message({
          type: 'error',
          message: 'Erro ao deletar alguns vídeos',
        })
      } finally {
        this.loading = false
      }
    },
    
    async deletarVideoCompleto(video) {
      try {
        // Deletar do AWS
        if (video.vsl_key_name) {
          await this.deletarAWS(video.vsl_key_name)
        }
        
        // Deletar frame
        await this.deletarFrame(video.id)
        
        // Deletar thumbnails
        await this.deletarThumb(video.id)
        
        // Deletar do banco de dados
        await this.deleteVSL(video.id)
      } catch (error) {
        console.error(`Erro ao deletar vídeo ${video.id}:`, error)
        throw error
      }
    },
    
    async deletarAWS(keyName) {
      try {
        await apiAws.delete('/remover-folder', {
          params: {
            folder_key_name: keyName,
          },
        })
      } catch (error) {
        console.error('Erro ao deletar do AWS:', error)
      }
    },
    
    async deletarFrame(videoId) {
      try {
        const options = {
          method: 'DELETE',
          url: `${process.env.VUE_APP_HOST_API_AWS_S3 || "/api/dkbucket"}/`,
          params: { key: `Thumb_frame/thumb_frame-${videoId}.png` },
        }
        await axios.request(options)
      } catch (error) {
        console.error('Erro ao deletar frame:', error)
      }
    },
    
    async deletarThumb(videoId) {
      try {
        const response = await axios.get(`${this.VUE_APP_HOST_API_BACKEND}/tumb_vsl/${videoId}`)
        
        if (response.data && response.data[0]) {
          const thumbData = response.data[0]
          const thumbs = [
            thumbData.tumb_key_name_start,
            thumbData.thumb_key_name_pausa,
            thumbData.thumb_key_name_end,
          ].filter(thumbKey => thumbKey && thumbKey !== 'undefined')
          
          // Deletar todos os thumbnails em paralelo
          await Promise.all(thumbs.map(thumbKey => axios.delete(`${process.env.VUE_APP_HOST_API_AWS_S3 || "/api/dkbucket"}/`, {
            params: { key: thumbKey },
          })))
        }
      } catch (error) {
        console.error('Erro ao deletar thumbnails:', error)
      }
    },
    
    async deleteVSL(vslId) {
      try {
        await VslService.deleteVsl(vslId)
      } catch (error) {
        console.error('Erro ao deletar VSL do banco:', error)
        throw error
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/card_Mover/card_mover.scss';

[dir] .el-dialog__body {
  padding-bottom: 5px 20px !important;
}

#card-checked {
  //width: 87%;
  //height: 17%;
  //padding: 0%;
  //left: 9%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 101rem;
  width: calc(100vw - 6.875rem);
  position: fixed;
  bottom: 1.5rem;
  background: var(--dk-bg-card, #fff);
  border: 0.0625rem solid var(--dk-border-light, #f5f5f5);
  border-radius: 4px;
  box-shadow: 0 0.5625rem 1.75rem 0.5rem rgb(0 0 0 / 5%), 0 0.375rem 1rem rgb(0 0 0 / 8%), 0 0.1875rem 0.375rem -0.25rem rgb(0 0 0 / 12%);
  padding: 1rem 1.5rem;
  z-index: 1000;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

#card-main {
  padding-left: 10px;
  padding-right: 0;
}

[dir] .el-card__body,
[dir] .el-main {
  padding: 10px 20px;
  width: 100% !important;
}

.row-bg {
  padding: 10px 0;
  background-color: var(--dk-bg-card-hover, #f9fafc);
}

div.ajust-padding-card {
  padding: 0;
}


</style>
